<div class="mcv_banner">
    <table class="width-100 no-border" cellspacing="0" cellpadding="0">
        <tbody>
            <tr> 
                 <td width="6%&quot;" nowrap="" class="mcv_banner_field bold-weight small">&nbsp;</td>		  
                 <td class="mcv_banner_field bold-weight small" width="9%" nowrap="">{{'MCVHEADER.CLIENT_NAME' | translate}}</td>
                 <td class="mcv_banner_field bold-weight small" width="18%" nowrap="" id="clientName">{{ clientName | translate }}</td>
                 <td class="mcv_banner_field bold-weight small" width="6%" nowrap="">{{'MCVHEADER.USER_ID' | translate}}</td>
                 <td class="mcv_banner_field bold-weight small" width="18%" nowrap="">{{ userId | translate }}</td>
                 <td class="mcv_banner_field bold-weight small" width="10%" nowrap="">{{'MCVHEADER.SUSCRIBER_ID' | translate}}</td>
                 <td *ngIf='loginId !== ""'
                    class="mcv_banner_field bold-weight small" width="18%" nowrap="">{{ loginId | translate }}
                 </td>
                 <td *ngIf='loginId === ""'
                 class="mcv_banner_field bold-weight small" width="18%" nowrap="">{{ subscriberId | translate }}
                </td>
                 <td width="15%" nowrap="" class="mcv_banner_field bold-weight small">	
                     <input name="Submit" type="submit" class="TextBlackNormal button" [value]="'MCVHEADER.LOGOUT' | translate" (click)="onLogoutClick()">
                </td>
            </tr>
        </tbody>
    </table>
</div> 